import { Component, Input, OnInit } from '@angular/core';
import { WorkspaceDatabaseKeys } from '@database/workspace';
import { SortingState, SortingStatus } from '@domain/sorting';
import { SortingTypeEnum } from '@shared';
import { map, Observable } from 'rxjs';

@Component({
	selector: 'app-sorting-button',
	templateUrl: './sorting-button.component.html',
	styleUrls: ['./sorting-button.component.scss']
})
export class SortingButtonComponent implements OnInit {
	@Input() public tableName: string;

	public isNotDefaultSort$: Observable<boolean>;

	public constructor(private sortState: SortingState) {}

	public ngOnInit(): void {
		this.isNotDefaultSort$ = this.sortState
			.getTableSortState(this.tableName)
			.pipe(
				map(
					(sortStatus: SortingStatus) =>
						!(
							sortStatus.selectedColumn.name === WorkspaceDatabaseKeys.internalColumns.rxdbid &&
							sortStatus.sortDirection === SortingTypeEnum.Ascending
						)
				)
			);
	}
}
